(function () {
  const PLACEHOLDER_SELECTOR = '[data-lazy-script]';
  const loadedScripts = {};

  function primeLoadedScripts() {
    document.querySelectorAll('script[src]').forEach((script) => {
      if (script.src) {
        loadedScripts[script.src] = true;
      }
    });
  }

  function hasLoaded(src) {
    return !!loadedScripts[src];
  }

  function markLoaded(src) {
    loadedScripts[src] = true;
  }

  function loadScript(placeholder) {
    if (!placeholder || placeholder.dataset.lazyLoaded === 'true') return;
    const src = placeholder.getAttribute('data-src');
    if (!src) return;

    if (hasLoaded(src)) {
      placeholder.remove();
      return;
    }

    const script = document.createElement('script');
    script.src = src;

    if (placeholder.dataset.scriptId) {
      script.id = placeholder.dataset.scriptId;
    }

    if (placeholder.dataset.scriptType) {
      script.type = placeholder.dataset.scriptType;
    }

    if (placeholder.dataset.async === 'true') {
      script.async = true;
    } else if (placeholder.dataset.defer !== 'false') {
      script.defer = true;
    }

    script.dataset.lazyLoaded = 'true';

    script.addEventListener('error', () => {
      loadedScripts[src] = false;
    });

    document.head.appendChild(script);
    markLoaded(src);
    placeholder.remove();
  }

  const interactionQueue = (() => {
    let queued = [];
    let armed = false;
    let triggered = false;

    function flush() {
      queued.forEach(loadScript);
      queued = [];
    }

    function arm() {
      if (armed || triggered) return;
      armed = true;

      const onTrigger = () => {
        triggered = true;
        armed = false;
        flush();
        window.removeEventListener('pointerdown', onPointer);
        window.removeEventListener('keydown', onKey);
      };

      const onPointer = () => onTrigger();
      const onKey = () => onTrigger();

      window.addEventListener('pointerdown', onPointer, {
        once: true,
        passive: true,
      });
      window.addEventListener('keydown', onKey, { once: true });
    }

    return {
      add(placeholder) {
        if (triggered) {
          loadScript(placeholder);
          return;
        }
        queued.push(placeholder);
        arm();
      },
    };
  })();

  const intersectionObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const target = entry.target;
                observer.unobserve(target);
                loadScript(target);
              }
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  function scheduleLoad(placeholder) {
    const trigger = placeholder.dataset.trigger || 'visible';

    if (trigger === 'visible' && intersectionObserver) {
      intersectionObserver.observe(placeholder);
      return;
    }

    if (trigger === 'idle') {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => loadScript(placeholder), { timeout: 2000 });
      } else {
        setTimeout(() => loadScript(placeholder), 1500);
      }
      return;
    }

    if (trigger === 'interaction') {
      interactionQueue.add(placeholder);
      return;
    }

    loadScript(placeholder);
  }

  function initPlaceholders(root) {
    const scope = root || document;
    const placeholders = scope.querySelectorAll(PLACEHOLDER_SELECTOR);

    placeholders.forEach((placeholder) => {
      if (placeholder.dataset.lazyBound === 'true') return;
      placeholder.dataset.lazyBound = 'true';
      scheduleLoad(placeholder);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPlaceholders(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!intersectionObserver) return;
    event.target
      .querySelectorAll(PLACEHOLDER_SELECTOR)
      .forEach((el) => intersectionObserver.unobserve(el));
  });

  primeLoadedScripts();
  initPlaceholders();
})();

